import { EvtHeader } from "components/header";
import React from "react";
import QuadrimesterForm from "@/modules/performance/quad/form";

const CreateQuadrimester = () => {
  return (
    <div className="flex-1 ">
      <EvtHeader title="Create Quadrimester" />
      <div className="max-w-md p-6">
        <QuadrimesterForm />
      </div>
    </div>
  );
};

export default CreateQuadrimester;
